module.exports = __webpack_public_path__ + "static/media/logo-negativa.af312fba.png";